import { useSelector } from "react-redux";
import { datetime } from "../../../../../util/library/datetime";
import { aDayMillisecond } from "../../../../../util/varibles/constants";
import { getMondayByKey } from "../../../../../util/varibles/global";
import { IVessel } from "../../../../../util/varibles/interface";
import { selectPlan } from "../../../constants";
import styles from '../style.module.scss';
import CurrentDay from "./CurrentDay";
import Day from "./Day";

const week = [0, 1, 2, 3, 4, 5, 6];
const colors = ["#B2D2CF", "#B6D2D8", "#C8D9DF", "#CFE2E3", "#E9E9DD", "#F3F2EC", '#F9F8F6', '#FFF']

interface IProps {
    vessels: IVessel[]
}

export default function Weeks({ vessels }: IProps) {
    const weeks = useSelector(selectPlan.weeks);

    return <div className={styles.weeks}>
        {weeks.map(id => {
            const value = id.split('|');
            const time = getMondayByKey(id).time;
            return <div id={id} key={id} className={styles.week}>
                <div className={styles.weekDays}>
                    <div className={styles.weekNo}>WEEK {value[1]}</div>
                    <div className="grid grid-cols-7 h-[24px] leading-[24px] text-[13px] text-[var(--colorSub)] text-center w-max">
                        {week.map(i => {
                            return <span
                                key={time + i}
                                className="whitespace-nowrap w-[var(--date-per-screen)]"
                            >
                                {datetime(time).add(i, 'day').format('ddd DD')}
                            </span>
                        })}
                    </div>
                </div>
                <div>
                    {vessels.map((item, i) => {
                        const { id } = item;
                        const styleDays = {
                            height: `calc(var(--${id}) + var(--more-height, 0px))`,
                            backgroundColor: colors[i % colors.length],
                        }
                        return <div key={i} className={styles.days} style={styleDays}>
                            {week.map((sub, subI) => <Day key={sub} time={time + (subI * aDayMillisecond)} vessel={item} />)}
                        </div>
                    })}
                </div>
            </div>
        })}
        <CurrentDay />
    </div>;
}